import { render, staticRenderFns } from "./SickKepu.vue?vue&type=template&id=2402099c&scoped=true"
import script from "./SickKepu.vue?vue&type=script&lang=js"
export * from "./SickKepu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2402099c",
  null
  
)

export default component.exports